const BASE_URL = import.meta.env?.VITE_APP_API_URL ?? process.env.BASE_URL;

export default {
  BASE_URL,
  // OPEN_API_URL: process.env.OPEN_API_URL,
};
